import { PLAYER_INVITE_AND_EARN } from '~/utils/api-response/player'

// State
export const state = () => ({
  referFriend: {
    total: 0,
    total_commission: 0,
    total_pages: 0,
    number_of_friend: 0,
    available_commission: 0,
    is_claimable: false,
    data: []
  },
  loading: false,
  friendList: {
    total: 1,
    total_win_loss: 0,
    total_turnover: 0,
    total_reward_amount: '0',
    totalPages: 1,
    data: [
      {
        total_non_promo_win_loss_amount: 0,
        total_non_promo_turnover_amount: 0,
        player_id: 'testactson2',
        created_at: '2025-06-06T04:37:33.435Z',
        total_reward_amount: '0'
      }
    ]
  }
})

// Actions
export const actions = {
  // get refer friend
  getReferFriend({ commit }, params) {
    const response = PLAYER_INVITE_AND_EARN
    commit('setReferFriend', response.data)
  },
  // get refer friend
  async friendList({ commit }, params) {},
  // get refer friend
  doClaimCommission({ commit }) {
    return true
  }
}

// Mutations
export const mutations = {
  setReferFriend: (state, val) => {
    state.referFriend = val
  },
  friendList: (state, val) => {
    state.friendList = val
  },
  setLoading: (state, val) => {
    state.loading = val
  }
}

// Getters
export const getters = {
  referFriend: state => {
    return state.referFriend
  },
  friendList: state => {
    return state.friendList
  }
}
